import React from 'react';
import ChevronUp from '../../assets/images/icons/chevron-up.svg';
import ChevronDown from '../../assets/images/icons/chevron-down.svg';
import ChevronColoured from '../../assets/images/icons/chevron-down-colored.svg';
import FacebookSquare from '../../assets/images/icons/facebook.svg';
import InstagramSquare from '../../assets/images/icons/instagram.svg';
import Instagram from '../../assets/images/icons/instagram.svg';
import InstagramRound from '../../assets/images/icons/instagram.svg';
import YoutubeSquare from '../../assets/images/icons/youtube.svg';
import LinkedInSquare from '../../assets/images/icons/linkedin.svg';
import TwitterSquare from '../../assets/images/icons/twitter.svg';
import Critical from '../../assets/images/icons/critical.svg';
import Info from '../../assets/images/icons/info-circle.svg';
import Information from '../../assets/images/icons/information.svg';
import Close from '../../assets/images/icons/close.svg';
import Warning from '../../assets/images/icons/warning.svg';
import FacebookRound from '../../assets/images/icons/facebook.svg';
import LinkedInRound from '../../assets/images/icons/linkedin.svg';
import TwitterRound from '../../assets/images/icons/twitter.svg';
import Search from '../../assets/images/icons/search.svg';
import SearchGreen from '../../assets/images/icons/search-green.svg';
import Location from '../../assets/images/icons/location.svg';
import LocationArrow from '../../assets/images/icons/location-arrow.svg';
import LocationExternal from '../../assets/images/icons/location-external.svg';
import LocationHome from '../../assets/images/icons/location-home.svg';
import DefaultProfile from '../../assets/images/icons/profile-md.svg';
import Map from '../../assets/images/icons/map.svg';
import MapMarker from '../../assets/images/icons/map-marker.svg';
import Menu from '../../assets/images/icons/menu.svg';
import ArrowGo from '../../assets/images/icons/arrow-go.svg';
import ArrowGoDefault from '../../assets/images/icons/arrow-go-md.svg';
import ArrowLeft from '../../assets/images/icons/arrow-left.svg';
import Profile from '../../assets/images/icons/profile.svg';
import ImageGrid from '../../assets/images/icons/image_grid.svg';
import ChevronLeftIcon from '../../assets/images/icons/chevron-left.svg';
import ChevronRightIcon from '../../assets/images/icons/chevron-right.svg';
import Share from '../../assets/images/icons/share.svg';
import Print from '../../assets/images/icons/print.svg';
import Calender from '../../assets/images/icons/calendar.svg';
import Calender_new from '../../assets/images/icons/calendar_new.svg';
import Expand from '../../assets/images/icons/expand.svg';
import ExpandFS from '../../assets/images/icons/expand-fs.svg';
import PlayFilled from '../../assets/images/icons/play-filled.svg';
import ChevronIcon from '../../assets/images/icons/chevron-next.svg';
import MapParking from '../../assets/images/icons/map-parking.svg';
import CellPhone from '../../assets/images/icons/cellphone.svg';
import Nurse from '../../assets/images/icons/nurse.svg';
import CalendarTwo from '../../assets/images/icons/calendar-two.svg';
import MenuThree from '../../assets/images/icons/menu-three.svg';
import CloseHeader from '../../assets/images/icons/close-header.svg';
import PlayBtn from '../../assets/images/icons/play-btn.svg';
import PauseBtn from '../../assets/images/icons/pause-btn.svg';
import Circle from '../../assets/images/icons/circle.svg';
import Square from '../../assets/images/icons/square.svg';
import Triangle from '../../assets/images/icons/triangle.svg';
import MyChart from '../../assets/images/icons/i-mychart-icon.svg';
import LocationIcon from '../../assets/images/icons/i-location-icon.svg';
import ICellPhoneIconRBG from '../../assets/images/icons/i-cellphone-icon-rgb.svg';
import ConCall from '../../assets/images/icons/con-call.svg';
import ConApply from '../../assets/images/icons/con-apply.svg';
import ConSchedule from '../../assets/images/icons/con-schedule.svg';
import GetCareNowIcon from '../../assets/images/icons/get-care-now-icon.svg';
import LocationPinned from '../../assets/images/icons/location-pinned-icon.svg';
import Star from '../../assets/images/icons/star.svg';
import Phone from '../../assets/images/icons/phone.svg';
import External from '../../assets/images/icons/external.svg';
import Copy from '../../assets/images/icons/copy.svg';
import Person from '../../assets/images/icons/person.svg';
import PLDCalender from '../../assets/images/icons/pld-calendar.svg';
import StartOver from '../../assets/images/icons/start-over.svg';
import ClareRGB from '../../assets/images/icons/i-clare-rgb.svg';
import Envelope from '../../assets/images/icons/envelope.svg';
import RoundedPhone from '../../assets/images/icons/rounded-phone.svg';
import TwitterX from '../../assets/images/icons/twitter-x.svg';
import TwitterXRound from '../../assets/images/icons/twitter-x.svg';
import PinterestRound from '../../assets/images/icons/pinterest.svg';
import PDCLocation from '../../assets/images/icons/pdc-location.svg';
import PDCCurrentLocation from '../../assets/images/icons/pdc-current-location.svg';
import Distance from '../../assets/images/icons/distance.svg';
import ModalTriangle from '../../assets/images/icons/modal-triangle.svg';
import InfoThin from '../../assets/images/icons/info-thin.svg';
import Checkmark from '../../assets/images/icons/checkmark.svg';
import Upload from '../../assets/images/icons/upload.svg';
import IconFormClose from '../../assets/images/icons/form-close.svg';
import PlayArrowRound from '../../assets/images/icons/play-arrow-round.svg';
import Filters from '../../assets/images/icons/filters.svg';
import PLDChevronDown from '../../assets/images/icons/pld-chevron-down.svg';
import PLDChevronLeft from '../../assets/images/icons/pld-chevron-left.svg';
import PLDChevronRight from '../../assets/images/icons/pld-chevron-right.svg';
import PLDLocationPin from '../../assets/images/icons/pld-location-pin.svg';
import PLDPatientCard from '../../assets/images/icons/pld-patient-card.svg';
import PLDSchedule from '../../assets/images/icons/pld-schedule.svg';
import PLDPhone from '../../assets/images/icons/pld-phone.svg';
import PLDWalkIn from '../../assets/images/icons/pld-walk-in.svg';
import PLDGreenSearch from '../../assets/images/icons/pld-green-search.svg';
import PLDBuilding from '../../assets/images/icons/pld-building.svg';
import PLDBuildingFilled from '../../assets/images/icons/pld-building_filled.svg';
import PLDServices from '../../assets/images/icons/pld-services.svg';
import PLDServicesFilled from '../../assets/images/icons/pld-services-filled.svg';
import PLDHeart from '../../assets/images/icons/pld-heart.svg';
import PLDHeartFilled from '../../assets/images/icons/pld-heart-filled.svg';
import PLDBlog from '../../assets/images/icons/pld-blog.svg';
import PLDBlogFilled from '../../assets/images/icons/pld-blog-filled.svg';
import PLDList from '../../assets/images/icons/pld-list.svg';
import PLDListFilled from '../../assets/images/icons/pld-list-filled.svg';
import PLDPerson from '../../assets/images/icons/pld-person.svg';
import PLDPersonFilled from '../../assets/images/icons/pld-person-filled.svg';
import PLDDocumentSearch from '../../assets/images/icons/pld-document-search.svg';
import PLDCalenderFilled from '../../assets/images/icons/pld-calender-filled.svg';
import CheckMarkCircle from '../../assets/images/icons/check-mark-circle.svg';
import CalendarLocation from '../../assets/images/icons/calendar-location.svg';
import PhoneNew from '../../assets/images/icons/phone-new.svg';
import LocationNew from '../../assets/images/icons/location-new.svg';
import ExternalNew from '../../assets/images/icons/external-new.svg';
import PrintNew from '../../assets/images/icons/print-new.svg';
import EditNew from '../../assets/images/icons/edit-new.svg';
import CopyNew from '../../assets/images/icons/copy-new.svg';
import ErrorCircleFilled from '../../assets/images/icons/error-circle-filled.svg';

type IconsProps = {
  id: string;
  className?: string;
  isDefault?: boolean;
  isColored?: boolean;
  removeSize?: boolean;
};

const Icons: React.FC<IconsProps> = ({
  id,
  isDefault,
  isColored,
  removeSize,
  ...props
}) => {
  switch (id) {
    case 'chevron-up':
      return <ChevronUp {...props} />;
    case 'icon-share':
      return <Share {...props} />;
    case 'icon-print':
      return <Print {...props} />;
    case 'chevron-down':
      return <ChevronDown {...props} />;
    case 'DownIcon':
      return <ChevronColoured {...props} />;
    case 'icon-critical':
    case 'critical':
      return <Critical {...props} />;
    case 'info-circle':
    case 'icon-info-circle':
    case 'default':
      return <Info {...props} />;
    case 'information':
      return <Information {...props} />;
    case 'close':
      return <Close {...props} />;
    case 'menu':
      return <Menu {...props} />;
    case 'image_grid':
      return <ImageGrid {...props} />;
    case 'arrow-left':
      return <ArrowLeft {...props} />;
    case 'arrow-go':
    case 'arrow-up':
    case 'icon-arrow-go':
      return isDefault ? <ArrowGoDefault {...props} /> : <ArrowGo {...props} />;
    case 'icon-profile':
      return isDefault ? <DefaultProfile {...props} /> : <Profile {...props} />;
    case 'facebook-square':
      return <FacebookSquare {...props} />;
    case 'instagram':
      return <Instagram {...props} />;
    case 'instagram-square':
      return <InstagramSquare {...props} />;
    case 'youtube':
    case 'youtube-square':
      return <YoutubeSquare {...props} />;
    case 'linkedin-square':
      return <LinkedInSquare {...props} />;
    case 'twitter-square':
      return <TwitterSquare {...props} />;
    case 'warning':
    case 'icon-warning':
      return <Warning {...props} />;
    case 'instagram-round':
      return <InstagramRound {...props} />;
    case 'facebook-round':
      return <FacebookRound {...props} />;
    case 'linkedin-round':
      return <LinkedInRound {...props} />;
    case 'twitter-round':
      return <TwitterRound {...props} />;
    case 'search':
    case '#search':
    case 'icon-search':
    case 'ìcon-search':
      return isColored ? <SearchGreen {...props} /> : <Search {...props} />;
    case 'icon-search-green':
      return <SearchGreen {...props} />;
    case 'location':
    case 'icon-location':
      return <Location {...props} />;
    case 'location-arrow':
      return <LocationArrow {...props} />;
    case 'location-external':
      return <LocationExternal {...props} />;
    case 'chevron-left-icon':
      return <ChevronLeftIcon {...props} />;
    case 'chevron-right-icon':
      return <ChevronRightIcon {...props} />;
    case 'icon-calendar':
      return <Calender {...props} />;
    case 'icon-calendarNew':
      return <Calender_new {...props} />;
    case 'calendar-two':
      return <CalendarTwo {...props} />;
    case 'icon-expand':
      return <Expand {...props} />;
    case 'icon-expand-fs':
      return <ExpandFS {...props} />;
    case 'icon-play-filled':
      return <PlayFilled {...props} />;
    case 'chevron-next':
      return <ChevronIcon {...props} />;
    case 'map-parking':
      return <MapParking {...props} />;
    case 'cellphone':
      return <CellPhone {...props} />;
    case 'nurse':
      return <Nurse {...props} />;
    case 'menu-three':
      return <MenuThree {...props} />;
    case 'close-header':
      return <CloseHeader {...props} />;
    case 'play-btn':
      return <PlayBtn {...props} />;
    case 'pause-btn':
      return <PauseBtn {...props} />;
    case 'map':
      return <Map {...props} />;
    case 'map-marker':
      return <MapMarker {...props} />;
    case 'location-home':
      return <LocationHome {...props} />;
    case 'circle':
      return <Circle {...props} />;
    case 'square':
      return <Square {...props} />;
    case 'triangle':
      return <Triangle {...props} />;
    case 'mychart':
      return <MyChart {...props} />;
    case 'location-icon':
      return <LocationIcon {...props} />;
    case 'i-cellphone-icon-rgb':
      return <ICellPhoneIconRBG {...props} />;
    case 'con-call':
      return <ConCall {...props} />;
    case 'con-apply':
      return <ConApply {...props} />;
    case 'con-schedule':
      return <ConSchedule {...props} />;
    case 'get-care-now-icon':
      return <GetCareNowIcon {...props} />;
    case 'location-pinned':
      return <LocationPinned {...props} />;
    case 'star':
      return <Star {...props} />;
    case 'phone':
      return <Phone {...props} />;
    case 'external':
      return <External {...props} />;
    case 'copy':
      return <Copy {...props} />;
    case 'person':
      return <Person {...props} />;
    case 'pld-calendar':
      return <PLDCalender {...props} />;
    case 'start-over':
      return <StartOver {...props} />;
    case 'i-clare-rgb':
      return <ClareRGB {...props} />;
    case 'envelope':
      return <Envelope {...props} />;
    case 'rounded-phone':
      return <RoundedPhone {...props} />;
    case 'twitter-x':
      return <TwitterX {...props} />;
    case 'twitter-x-round':
      return <TwitterXRound {...props} />;
    case 'pinterest-round':
      return <PinterestRound {...props} />;
    case 'icon-pdc-location':
      return <PDCLocation {...props} />;
    case 'icon-pdc-current-location':
      return <PDCCurrentLocation {...props} />;
    case 'icon-distance':
      return <Distance {...props} />;
    case 'icon-modal-triangle':
      return <ModalTriangle {...props} />;
    case 'icon-info-thin':
      return <InfoThin {...props} />;
    case 'icon-checkmark':
      return <Checkmark {...props} />;
    case 'icon-upload':
      return <Upload {...props} />;
    case 'icon-form-close':
      return <IconFormClose {...props} />;
    case 'icon-play-arrow-round':
      return <PlayArrowRound {...props} />;
    case 'icon-filters':
      return <Filters {...props} />;
    case 'pld-chevron-down':
      return <PLDChevronDown {...props} />;
    case 'pld-chevron-left':
      return <PLDChevronLeft {...props} />;
    case 'pld-chevron-right':
      return <PLDChevronRight {...props} />;
    case 'pld-location-pin':
      return <PLDLocationPin {...props} />;
    case 'pld-patient-card':
      return <PLDPatientCard {...props} />;
    case 'pld-schedule':
      return <PLDSchedule {...props} />;
    case 'pld-phone':
      return <PLDPhone {...props} />;
    case 'pld-walk-in':
      return <PLDWalkIn {...props} />;
    case 'pld-green-search':
      return <PLDGreenSearch {...props} />;
    case 'pld-building':
      return <PLDBuilding {...props} />;
    case 'pld-building-filled':
      return <PLDBuildingFilled {...props} />;
    case 'pld-services':
      return <PLDServices {...props} />;
    case 'pld-services-filled':
      return <PLDServicesFilled {...props} />;
    case 'pld-heart':
      return <PLDHeart {...props} />;
    case 'pld-heart-filled':
      return <PLDHeartFilled {...props} />;
    case 'pld-blog':
      return <PLDBlog {...props} />;
    case 'pld-blog-filled':
      return <PLDBlogFilled {...props} />;
    case 'pld-list':
      return <PLDList {...props} />;
    case 'pld-list-filled':
      return <PLDListFilled {...props} />;
    case 'pld-person':
      return <PLDPerson {...props} />;
    case 'pld-person-filled':
      return <PLDPersonFilled {...props} />;
    case 'pld-document-search':
      return <PLDDocumentSearch {...props} />;
    case 'icon-calendarNew-filled':
      return <PLDCalenderFilled {...props} />;
    case 'icon-checkmark-circle':
      return <CheckMarkCircle {...props} />;
    case 'icon-calendar-location':
      return <CalendarLocation {...props} />;
    case 'icon-phone-new':
      return <PhoneNew {...props} />;
    case 'icon-location-new':
      return <LocationNew {...props} />;
    case 'icon-external-new':
      return <ExternalNew {...props} />;
    case 'icon-print-new':
      return <PrintNew {...props} />;
    case 'icon-edit-new':
      return <EditNew {...props} />;
    case 'icon-copy-new':
      return <CopyNew {...props} />;
    case 'icon-error-circle-filled':
      return <ErrorCircleFilled {...props} />;
    default:
      return <></>;
  }
};

export default Icons;
